/** @format */
import { useEffect } from 'react';

/**
 * @deprecated use Feather/hooks/use-key-press instead
 */
export const useKeyPress = (
    element: HTMLElement | Window | null,
    targetKeys: string[],
    handler: (event: KeyboardEvent) => void
) => {
    // If pressed key is our target key then set to true
    function downHandler(event: Event) {
        if (targetKeys.includes((event as KeyboardEvent).key)) {
            handler(event as KeyboardEvent);
        }
    }

    // Add event listeners
    useEffect(() => {
        element && element.addEventListener('keydown', downHandler);

        // Remove event listeners on cleanup
        return () => {
            element && element.removeEventListener('keydown', downHandler);
        };
    }, [element, handler]);
};
